import { render } from "./InviteContract.vue?vue&type=template&id=5a8793e6"
import script from "./InviteContract.vue?vue&type=script&lang=js"
export * from "./InviteContract.vue?vue&type=script&lang=js"

import "./InviteContract.vue?vue&type=style&index=0&id=5a8793e6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__